// src/Informes/Components/Items.js
import React from "react";
import { Grid } from "@mui/material";

export const Item = ({ item }) => (
  <Grid item xs={6} sx={{ position: "relative" }}>
    <span style={{ display: "inline-block", width: "85%" }}>
      {item.label + " "}
    </span>
    <span style={{ position: "absolute", right: "20px" }}>
      {item.value + "%"}
    </span>
    <hr></hr>
  </Grid>
);

export const ItemList = ({ items }) => (
  <Grid container>
    {items.map((item) => (
      <Item key={item.case_status} item={item} />
    ))}
  </Grid>
);
